var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoSaidaInactivo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Sa\xEDda Inactivo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-140.000000, -166.000000)",
    stroke: "#31383E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Sa\\xEDda-Inactivo",
    transform: "translate(141.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9544861,3.1385357 C10.9544861,1.40513823 9.5080557,3.44303797e-05 7.72367595,3.44303797e-05 L3.23091646,3.44303797e-05 C1.44653671,3.44303797e-05 -7.08860759e-05,1.40513823 -7.08860759e-05,3.1385357 L-7.08860759e-05,8.24111797 C-7.08860759e-05,9.97451544 1.44653671,11.3796192 3.23091646,11.3796192 L7.72367595,11.3796192",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5543316,8.99438582 L13.8960278,8.99438582 L13.8960278,7.38493772 C13.8960278,7.38493772 12.8339772,5.98189975 10.7524076,5.98189975 C10.7524076,5.98189975 9.81777468,4.70263899 8.33093924,4.4137681 L5.56974937,4.4137681 C5.56974937,4.4137681 4.50769873,4.57868962 3.02086329,5.94058329 L2.2136481,5.94058329 C2.2136481,5.94058329 1.95881266,6.35323139 1.95881266,7.67380861 C1.95881266,7.67380861 1.78886329,8.99438582 2.85091392,8.99438582 L3.25443291,8.99438582",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67588354,8.99438582 L10.1328456,8.99438582",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "9.94526329 6.18818937 9.47794684 6.4357438 5.44222532 6.4357438 4.86875696 5.87866025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67588354,8.99438582 C5.67588354,9.64391494 5.13378228,10.1705276 4.46514937,10.1705276 C3.79651646,10.1705276 3.25441519,9.64391494 3.25441519,8.99438582 C3.25441519,8.34485671 3.79651646,7.81824405 4.46514937,7.81824405 C5.13378228,7.81824405 5.67588354,8.34485671 5.67588354,8.99438582 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5543316,8.99438582 C12.5543316,9.64391494 12.0122304,10.1705276 11.3435975,10.1705276 C10.6749646,10.1705276 10.1328633,9.64391494 10.1328633,8.99438582 C10.1328633,8.34485671 10.6749646,7.81824405 11.3435975,7.81824405 C12.0122304,7.81824405 12.5543316,8.34485671 12.5543316,8.99438582 Z",
    id: "Stroke-11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSaidaInactivo);
export default __webpack_public_path__ + "static/media/PictoSaidaInactivo.806c717958d66e267969c7c7ce557fe2.svg";
export { ForwardRef as ReactComponent };